import { render, staticRenderFns } from "./CompanyBoardModal.vue?vue&type=template&id=076d4f21"
import script from "./CompanyBoardModal.vue?vue&type=script&lang=js"
export * from "./CompanyBoardModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyBoardModal.vue?vue&type=style&index=0&id=076d4f21&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports